import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Fonts } from "../../Themes/Fonts";
import AuthenticationActions, { AuthenticationSelectors } from "../../Redux/AuthenticationRedux";
import PasswordResetForm from "../../Forms/PasswordResetForm/PasswordResetForm";
import SweetAlert from "react-bootstrap-sweetalert";
import queryString from 'query-string'

import styles from "./styles";
import { withStyles } from "@material-ui/styles";

const RenderAlert = props => {
  return (
    <SweetAlert
      success
      confirmBtnText="Close"
      confirmBtnBsStyle="default"
      cancelBtnBsStyle="default"
      title="Password Change"
      onConfirm={props.resetClose}
    />
  );
};

class PasswordResetScreen extends Component {
  state = {
    showAlert: false,
    fetching: false
  };

  componentDidUpdate(prevProps) {
    const { fetching, error } = this.props;
    if (prevProps.fetching !== fetching && !fetching && !error) {
      this.setState({
        showAlert: true,
        fetching: false
      });
    }
  }

  resetClose = () => {
    const { history } = this.props;
    this.setState({
      showAlert: false
    });
    history.push("/Login")
  };

  handleSubmit = vals => {
    const url = queryString.parse(this.props.location.search)
    const queryToken = url.q
    const data = {
      password: vals.password,
      token: queryToken
    };
    this.setState({
      fetching: true
    });
    this.props.passwordReset(data);
  };

  render() {
    const { showAlert, fetching } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        {showAlert ? <RenderAlert resetClose={this.resetClose} /> : null}
        <h1 style={Fonts.headerFont}>Reset your password</h1>
        <PasswordResetForm onSubmit={this.handleSubmit} fetching={fetching} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    action: AuthenticationSelectors.getAction(state),
    fetching: AuthenticationSelectors.getFetching(state),
    error: AuthenticationSelectors.getError(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    passwordReset: data => dispatch(AuthenticationActions.passwordResetRequest(data))
  };
};

const withRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)

export default compose(
  withStyles(styles), withRedux
)(PasswordResetScreen)

